<style scoped> 
    .label {
        font-weight: 600;
    }
</style>

<template>
    <div class="form-group">
        <label class="label required">{{ $t("Product") }}</label>
        <app-input
            :placeholder="$t('Select product')"
            type="advance-search-select"
            fetch-url="/products/serverside/selectable-name"
            listValueField="name"
            v-model="selectedProduct"
            :loaded-per-time="5"
            :disabled="is_view"
        />
    </div>
</template>
  
<script>
export default {
    name: 'ProductDescription',
    props: {
        value: {
            type: [String, Number, Object],
            default: null
        },
        is_view : {
            type : Boolean,
            default : false
        }
    },
    emits: ['updateTariff'],
    computed: {
        selectedProduct: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('input', newValue);
            }
        }
    }
}
</script>